import { render, staticRenderFns } from "./special-edit.vue?vue&type=template&id=0db66a03"
import script from "./special-edit.vue?vue&type=script&lang=ts"
export * from "./special-edit.vue?vue&type=script&lang=ts"
import style0 from "./special-edit.vue?vue&type=style&index=0&id=0db66a03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports